import { useMemo } from 'react';

import { useCommonStore } from '@/store';

export const useMobileApps = () => {
  const mobileAppCMS = useCommonStore.use.mobileAppCMS();
  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const isAnyAppsDesktop = useCommonStore.use.isAnyAppsDesktop();
  const isNoAppsMobile = useCommonStore.use.isNoAppsMobile();

  const isAnyMobileApps = useMemo(() => {
    if (!mobileAppCMS) return true;
    if (isMobileDevice) return isNoAppsMobile;
    return !isAnyAppsDesktop;
  }, [mobileAppCMS, isMobileDevice, isAnyAppsDesktop, isNoAppsMobile]);

  return { isAnyMobileApps };
};
